import MaterialTypes from './Displays/MaterialTypes'

export default MaterialTypes
